/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Fintecy Investors API
 * API for managing investors, accounts, and transactions in the Fintecy platform
 * OpenAPI spec version: 1.0.0
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery } from '@tanstack/react-query';

import type {
  Error,
  GetAllTransactionsParams,
  ImportTransactionsFromCsvBody,
  ImportTransactionsFromCsvParams,
  ParseStatementParams,
  StatementParseRequest,
  StatementParseResponse,
  Transaction,
  TransactionImportResponse,
  TransactionInput,
  TransactionListResponse,
} from '.././model';

import { customInstance } from '../../axios-instance';

/**
 * Returns a paginated list of transactions for the authenticated user. Filter by accountId to scope to a single account.
 * @summary Get all transactions
 */
export const getAllTransactions = (params?: GetAllTransactionsParams, signal?: AbortSignal) => {
  return customInstance<TransactionListResponse>({
    url: `/api/transactions`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetAllTransactionsQueryKey = (params?: GetAllTransactionsParams) => {
  return [`/api/transactions`, ...(params ? [params] : [])] as const;
};

export const getGetAllTransactionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllTransactions>>,
  TError = Error,
>(
  params?: GetAllTransactionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTransactions>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllTransactionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllTransactions>>> = ({ signal }) =>
    getAllTransactions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllTransactions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllTransactionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllTransactions>>
>;
export type GetAllTransactionsQueryError = Error;

export function useGetAllTransactions<
  TData = Awaited<ReturnType<typeof getAllTransactions>>,
  TError = Error,
>(
  params: undefined | GetAllTransactionsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTransactions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllTransactions>>,
          TError,
          Awaited<ReturnType<typeof getAllTransactions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllTransactions<
  TData = Awaited<ReturnType<typeof getAllTransactions>>,
  TError = Error,
>(
  params?: GetAllTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllTransactions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllTransactions>>,
          TError,
          Awaited<ReturnType<typeof getAllTransactions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllTransactions<
  TData = Awaited<ReturnType<typeof getAllTransactions>>,
  TError = Error,
>(
  params?: GetAllTransactionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTransactions>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get all transactions
 */

export function useGetAllTransactions<
  TData = Awaited<ReturnType<typeof getAllTransactions>>,
  TError = Error,
>(
  params?: GetAllTransactionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTransactions>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAllTransactionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new transaction for the authenticated user
 * @summary Create a new transaction
 */
export const createTransaction = (transactionInput: TransactionInput, signal?: AbortSignal) => {
  return customInstance<Transaction>({
    url: `/api/transactions`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: transactionInput,
    signal,
  });
};

export const getCreateTransactionMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTransaction>>,
    TError,
    { data: TransactionInput },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTransaction>>,
  TError,
  { data: TransactionInput },
  TContext
> => {
  const mutationKey = ['createTransaction'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTransaction>>,
    { data: TransactionInput }
  > = (props) => {
    const { data } = props ?? {};

    return createTransaction(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTransactionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTransaction>>
>;
export type CreateTransactionMutationBody = TransactionInput;
export type CreateTransactionMutationError = Error;

/**
 * @summary Create a new transaction
 */
export const useCreateTransaction = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTransaction>>,
      TError,
      { data: TransactionInput },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createTransaction>>,
  TError,
  { data: TransactionInput },
  TContext
> => {
  const mutationOptions = getCreateTransactionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns a single transaction by its UUID
 * @summary Get transaction by ID
 */
export const getTransaction = (id: string, signal?: AbortSignal) => {
  return customInstance<Transaction>({ url: `/api/transactions/${id}`, method: 'GET', signal });
};

export const getGetTransactionQueryKey = (id: string) => {
  return [`/api/transactions/${id}`] as const;
};

export const getGetTransactionQueryOptions = <
  TData = Awaited<ReturnType<typeof getTransaction>>,
  TError = Error,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransaction>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTransactionQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransaction>>> = ({ signal }) =>
    getTransaction(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTransaction>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTransactionQueryResult = NonNullable<Awaited<ReturnType<typeof getTransaction>>>;
export type GetTransactionQueryError = Error;

export function useGetTransaction<
  TData = Awaited<ReturnType<typeof getTransaction>>,
  TError = Error,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransaction>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransaction>>,
          TError,
          Awaited<ReturnType<typeof getTransaction>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTransaction<
  TData = Awaited<ReturnType<typeof getTransaction>>,
  TError = Error,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransaction>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransaction>>,
          TError,
          Awaited<ReturnType<typeof getTransaction>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTransaction<
  TData = Awaited<ReturnType<typeof getTransaction>>,
  TError = Error,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransaction>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get transaction by ID
 */

export function useGetTransaction<
  TData = Awaited<ReturnType<typeof getTransaction>>,
  TError = Error,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransaction>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTransactionQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates an existing transaction
 * @summary Update transaction
 */
export const updateTransaction = (id: string, transactionInput: TransactionInput) => {
  return customInstance<Transaction>({
    url: `/api/transactions/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: transactionInput,
  });
};

export const getUpdateTransactionMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTransaction>>,
    TError,
    { id: string; data: TransactionInput },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTransaction>>,
  TError,
  { id: string; data: TransactionInput },
  TContext
> => {
  const mutationKey = ['updateTransaction'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTransaction>>,
    { id: string; data: TransactionInput }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTransaction(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTransactionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTransaction>>
>;
export type UpdateTransactionMutationBody = TransactionInput;
export type UpdateTransactionMutationError = Error;

/**
 * @summary Update transaction
 */
export const useUpdateTransaction = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTransaction>>,
      TError,
      { id: string; data: TransactionInput },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateTransaction>>,
  TError,
  { id: string; data: TransactionInput },
  TContext
> => {
  const mutationOptions = getUpdateTransactionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes an existing transaction (soft delete)
 * @summary Delete transaction
 */
export const deleteTransaction = (id: string) => {
  return customInstance<void>({ url: `/api/transactions/${id}`, method: 'DELETE' });
};

export const getDeleteTransactionMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTransaction>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTransaction>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteTransaction'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTransaction>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTransaction(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTransactionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTransaction>>
>;

export type DeleteTransactionMutationError = Error;

/**
 * @summary Delete transaction
 */
export const useDeleteTransaction = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTransaction>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTransaction>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteTransactionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Imports transactions from a CSV file for the authenticated user
 * @summary Import transactions from CSV
 */
export const importTransactionsFromCsv = (
  importTransactionsFromCsvBody: ImportTransactionsFromCsvBody,
  params: ImportTransactionsFromCsvParams,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  if (importTransactionsFromCsvBody.file !== undefined) {
    formData.append(`file`, importTransactionsFromCsvBody.file);
  }

  return customInstance<TransactionImportResponse>({
    url: `/api/transactions/import`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    params,
    signal,
  });
};

export const getImportTransactionsFromCsvMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importTransactionsFromCsv>>,
    TError,
    { data: ImportTransactionsFromCsvBody; params: ImportTransactionsFromCsvParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importTransactionsFromCsv>>,
  TError,
  { data: ImportTransactionsFromCsvBody; params: ImportTransactionsFromCsvParams },
  TContext
> => {
  const mutationKey = ['importTransactionsFromCsv'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importTransactionsFromCsv>>,
    { data: ImportTransactionsFromCsvBody; params: ImportTransactionsFromCsvParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return importTransactionsFromCsv(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportTransactionsFromCsvMutationResult = NonNullable<
  Awaited<ReturnType<typeof importTransactionsFromCsv>>
>;
export type ImportTransactionsFromCsvMutationBody = ImportTransactionsFromCsvBody;
export type ImportTransactionsFromCsvMutationError = Error;

/**
 * @summary Import transactions from CSV
 */
export const useImportTransactionsFromCsv = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof importTransactionsFromCsv>>,
      TError,
      { data: ImportTransactionsFromCsvBody; params: ImportTransactionsFromCsvParams },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof importTransactionsFromCsv>>,
  TError,
  { data: ImportTransactionsFromCsvBody; params: ImportTransactionsFromCsvParams },
  TContext
> => {
  const mutationOptions = getImportTransactionsFromCsvMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Stub for LLM-based statement parsing. Validates that the account and vault document belong to the authenticated user, then returns zero parsed transactions until the parser is implemented.

 * @summary Parse statement document into transactions
 */
export const parseStatement = (
  statementParseRequest: StatementParseRequest,
  params: ParseStatementParams,
  signal?: AbortSignal
) => {
  return customInstance<StatementParseResponse>({
    url: `/api/transactions/parse-statement`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: statementParseRequest,
    params,
    signal,
  });
};

export const getParseStatementMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof parseStatement>>,
    TError,
    { data: StatementParseRequest; params: ParseStatementParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof parseStatement>>,
  TError,
  { data: StatementParseRequest; params: ParseStatementParams },
  TContext
> => {
  const mutationKey = ['parseStatement'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof parseStatement>>,
    { data: StatementParseRequest; params: ParseStatementParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return parseStatement(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ParseStatementMutationResult = NonNullable<Awaited<ReturnType<typeof parseStatement>>>;
export type ParseStatementMutationBody = StatementParseRequest;
export type ParseStatementMutationError = Error;

/**
 * @summary Parse statement document into transactions
 */
export const useParseStatement = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof parseStatement>>,
      TError,
      { data: StatementParseRequest; params: ParseStatementParams },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof parseStatement>>,
  TError,
  { data: StatementParseRequest; params: ParseStatementParams },
  TContext
> => {
  const mutationOptions = getParseStatementMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
